import React from "react";
import "@fontsource/inter/700.css";
const DonutProgress = ({ value, color, size = 96, trackColor = "#E5E7EB", label }) => {
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div
      className="grid place-items-center rounded-full"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: `conic-gradient(${color} ${clamped * 3.6}deg, ${trackColor} 0deg)`,
      }}
    >
      <div
        className="grid place-items-center rounded-full bg-white text-[#1F2937]"
        style={{ width: `${size - 14}px`, height: `${size - 14}px` }}
      >
        <span className="text-xl sm:text-[26px] font-['Inter'] font-bold italic leading-none">{label ?? `${clamped}%`}</span>
      </div>
    </div>
  );
};

export default DonutProgress;
